// Mobile Mega Menu - Optimized
(function() {
  'use strict';

  // 使用事件委托处理 tab 切换
  function handleTabClick(tab) {
    const menu = tab.closest('.mobile-mega-menu');
    if (!menu) return;

    const targetTab = tab.getAttribute('data-tab');
    if (!targetTab) return;

    const tabs = menu.querySelectorAll('.mobile-mega-menu__tab');
    const contents = menu.querySelectorAll('.mobile-mega-menu__content');

    // 更新 tab 状态
    tabs.forEach(function(t) {
      t.classList.remove('active');
    });
    tab.classList.add('active');

    // 更新 content 状态
    contents.forEach(function(content) {
      const contentTab = content.getAttribute('data-content');
      if (contentTab === targetTab) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }

  // 事件委托 - 监听整个文档
  document.addEventListener('click', function(e) {
    const tab = e.target.closest('.mobile-mega-menu__tab');
    if (tab) {
      e.preventDefault();
      e.stopPropagation();
      handleTabClick(tab);
    }
  });

  // 初始化：默认激活第一个 tab 和 content
  function initFirstTab() {
    const menus = document.querySelectorAll('.mobile-mega-menu');
    menus.forEach(function(menu) {
      // 检查是否已有 active tab
      const activeTab = menu.querySelector('.mobile-mega-menu__tab.active');
      if (activeTab) return;

      // 激活第一个 tab
      const firstTab = menu.querySelector('.mobile-mega-menu__tab');
      if (firstTab) {
        firstTab.classList.add('active');
        const targetTab = firstTab.getAttribute('data-tab');
        if (targetTab) {
          const content = menu.querySelector('[data-content="' + targetTab + '"]');
          if (content) {
            content.classList.add('active');
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFirstTab);
  } else {
    initFirstTab();
  }

})();